<div class="card card-custom" xmlns="http://www.w3.org/1999/html">
    <!-- Header -->
    <div class="card-header border-0 py-5">
        <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Lista candidati</span>
            <!--            <span class="text-muted mt-3 font-weight-bold font-size-sm"-->
            <!--            >More than 400+ new members</span-->
            <!--            >-->
        </h3>
        <!--        <div class="card-toolbar">-->
        <!--            <a class="btn btn-primary font-weight-bold text-uppercase px-9 py-4" routerLink="/sistemerp/proiecte/adauga-proiect">-->
        <!--                Adauga proiect <span class="fa fa-plus-circle"></span>-->
        <!--            </a>-->
        <!--        </div>-->
    </div>
    <!--begin::Body-->



    <div class="card-body py-0">
        <form #searchForm="ngForm" class="filterForm">
            <div class="row filters-section align-items-end">

                <div class="col-md-3  form-group">
                    <label>Nume</label>
                    <input type="text" [(ngModel)]="candidate.firstName"
                           class="form-control"/>
                </div>
                <div class="col-md-3  form-group">
                    <label>Prenume</label>
                    <input type="text" [(ngModel)]="candidate.lastName"
                           class="form-control"/>
                </div>
                <div class="col-md-3  form-group">
                    <label>Email</label>
                    <input type="email" [(ngModel)]="candidate.email"
                           class="form-control" name="email"/>
                </div>
                <div class="col-md-2  form-group">
                    <label>Telefon</label>
                    <input type="phone" [(ngModel)]="candidate.telephone"
                           class="form-control"/>
                </div>
                <div class="col-md-1 text-right  form-group">
                    <button class="btn btn-light-primary px-3 font-weight-bold"
                            type="button"
                            (click)="candidatesCall();">
                        <span class="fa fa-search"></span>
                    </button>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <button class="btn btn-light-primary col-lg-12" type="button" data-toggle="collapse" data-target="#collapseSearch" aria-expanded="false" aria-controls="collapseExample">
                        Cautare avansata
                        <span class="fa fa-sliders-h"></span>
                    </button>
                </div>
                <div class="col-lg-12">
                    <div class="collapse" id="collapseSearch">
                        <div class="card card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <ngb-accordion [closeOthers]="false" #extraFields="ngbAccordion">
                                        <ngb-panel id="general-info">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Informatii generale candidat</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-3 form-group">
                                                        <label>Tara</label>
                                                        <select (change)="changeCountry($event)" [(ngModel)]="candidate.userCountry"
                                                                class="form-control"
                                                                id="userCountry" name="userCountry"  placeholder="Country" required>
                                                            <option [ngValue]="undefined">--Alege tara--</option>
                                                            <option *ngFor="let country of countries">{{country.name}}</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Oras</label>
                                                        <ng-select2
                                                                [(ngModel)]="candidate.city"
                                                                [data]="cities"
                                                                [options]="multiSelectOp"
                                                                name="city"
                                                        >
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Statut civil</label>
                                                        <select [(ngModel)]="candidate.civilStatus" class="form-control" name="civilStatus">
                                                            <option value="">--Alege o optiune--</option>
                                                            <option value="unmarried">Necasatorit/a</option>
                                                            <option value="married">Casatorit/a</option>
                                                            <option value="divorced">Divortat/a</option>
                                                            <option value="widower">Vaduv/a</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Gen</label>
                                                        <select [(ngModel)]="candidate.gender" class="form-control" name="gender">
                                                            <option value=""> -- Selecteaza optiune -- </option>
                                                            <option value="female">Femeie</option>
                                                            <option value="male">Barbat</option>
                                                            <option value="other">Altceva</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Limbi straine</label>
                                                        <ng-select2
                                                                [(ngModel)]="candidate.languages"
                                                                [data]="languages"
                                                                [options]="multiSelectOp"
                                                                name="languages"
                                                        >
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Studii</label>
                                                        <ng-select2
                                                                [(ngModel)]="candidate.studies"
                                                                [data]="studiesOp"
                                                                [options]="multiSelectOp"
                                                                name="studies"
                                                        >
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Permis de conducere</label>
                                                        <ng-select2
                                                                [(ngModel)]=candidate.driverLicense name="driverLicense"
                                                                [data]="driverLic"
                                                                [options]="multiSelectOp">
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Blacklist</label>
                                                        <select [(ngModel)]="candidate.blackListed" class="form-control" name="civilStatus">
                                                            <option [ngValue]="undefined">-- Alege o optiune --</option>
                                                            <option [ngValue]="true">DA</option>
                                                            <option [ngValue]="false">NU</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                        <ngb-panel id="actual-status">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Status actual</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-3 form-group">
                                                        <label>Status job actual</label>
                                                        <select type="text" class="form-control" [(ngModel)]=candidate.currentJob
                                                                name="currentJob">
                                                            <option [ngValue]="undefined"> -- Selecteaza optiune --</option>
                                                            <option class="form-control" value="Studii">Studii</option>
                                                            <option class="form-control" value="Angajat">Angajat</option>
                                                            <option class="form-control" value="Fara job">Fara job</option>
                                                            <option class="form-control" value="Voluntar">Voluntar</option>
                                                            <option class="form-control" value="Internship">Internship</option>
                                                            <option class="form-control" value="Angajat part time">Angajat part time</option>
                                                            <option class="form-control" value="Angajat full time">Angajat full time</option>
                                                            <option class="form-control" value="On project/temporar">On project/temporar
                                                            </option>
                                                            <option class="form-control" value="Freelancer(persona fizica)">Freelancer(persona
                                                                fizica)
                                                            </option>
                                                            <option class="form-control" value="Freelancer(persona juridica)">Freelancer(persona
                                                                juridica)
                                                            </option>
                                                            <option class="form-control" value="In cautare activa">In cautare activa</option>
                                                            <option class="form-control" value="In cautare pasiva">In cautare pasiva</option>
                                                            <option class="form-control" value="Antreprenor">Antreprenor</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Nivelul experientei actuala</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.currentExperienceLevel name="currentExperienceLevel">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="student">Studii</option>
                                                            <option value="entry_level">Entry-Level</option>
                                                            <option value="junior">Junior</option>
                                                            <option value="senior">Senior</option>
                                                            <option value="specialist">Specialist</option>
                                                            <option value="executive">Top Management</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Tip job</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.jobType name="jobType">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="field_job">Job de teren</option>
                                                            <option value="office_job">Job de birou</option>
                                                            <option value="remote">Remote</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Disponibilitate angajare</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.availableForWork name="availableForWork">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="immediate">Imediata</option>
                                                            <option value="in_30_days">In 30 zile</option>
                                                            <option value="in_90_days">In 90 zile</option>
                                                            <option value="in_6_months">In 6 luni</option>
                                                            <option value="in_9_months">In 9 luni</option>
                                                            <option value="in_12_months">In 12 luni</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Disponibilitate deplasare</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.userAvailableForTraveling name="userAvailableForTraveling">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="10%">10%</option>
                                                            <option value="25%">25%</option>
                                                            <option value="50%">50%</option>
                                                            <option value="100%">100%</option>
                                                            <option value="A">Altele</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                        <ngb-panel id="activity-domain">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Domeniu de activitate</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-4 form-group">
                                                            <label>Domeniu</label>
                                                            <select [(ngModel)]="selectedDomain" (change)="changeDomain($event)" class="form-control" name="userActivitySector">
                                                                <option *ngFor="let country of Domains">{{country.name}}</option>
                                                            </select>
                                                    </div>
                                                    <div class="col-md-4 form-group" *ngIf="subdomains">
                                                        <label>Subdomenii</label>
                                                        <ng-select2

                                                                [(ngModel)]="selectSubdomains"
                                                                [data]="subDomainsArray"
                                                                [options]="multiSelectOp"
                                                                (valueChanged)="changeSubDomain($event)"
                                                                name="userActivitySubSector"
                                                        >
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-4 form-group" *ngIf="selected">
                                                        <label>Categorii</label>
                                                        <ng-select2

                                                                [(ngModel)]="selectedCategories"
                                                                [data]="categoriesArray"
                                                                [options]="multiSelectOp"
                                                                name="category"
                                                        >
                                                        </ng-select2>
                                                    </div>
                                                    <div class="col-md-4 form-group">
                                                        <label>Departamente</label>
                                                        <ng-select2
                                                                [(ngModel)]="candidate.userDepartment"
                                                                [data]="departments"
                                                                [options]="multiSelectOp"
                                                                name="userDepartment">
                                                        </ng-select2>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>

                                        <ngb-panel id="geo-mobility">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Mobilitate geografica</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-3 form-group">
                                                        <label>Regiune de interes</label>
                                                        <select [(ngModel)]="candidate.regionOfInterest" class="form-control" name="regionOfInterest">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="INTERNAL">Intern(Romania)</option>
                                                            <option value="EXTERNAL">Extern(Strainatate)</option>
                                                            <option value="MIXED">Mix</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Disponibilitate relocare</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.availabilityOfRelocation name="availabilityOfRelocation">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="yes">Da</option>
                                                            <option value="no">Nu</option>
                                                            <option value="alone_in_romania">Singur in Romania</option>
                                                            <option value="alone_in_eu">Singur in UE</option>
                                                            <option value="with_family_in_romania">Cu familia in Romania
                                                            </option>
                                                            <option value="with_family_in_eu">Cu familia in UE</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Permis de munca in UE</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.workPermissionInEu name="workPermissionInEu">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="yes">Da</option>
                                                            <option value="no">Nu</option>
                                                            <option value="not_require">Nu este necesar</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                        <ngb-panel id="work-cond">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Conditii de lucru ideale</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-3 form-group">
                                                        <label>Nivel de job dorit</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.desiredLevelOfJob name="desiredLevelOfJob">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="student">Studii</option>
                                                            <option value="entry_level">Entry-Level</option>
                                                            <option value="junior">Junior</option>
                                                            <option value="senior">Senior</option>
                                                            <option value="specialist">Specialist</option>
                                                            <option value="executive">Top Management</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Program de lucru</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.userWorkProgram name="userWorkProgram">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="fixed">Fix</option>
                                                            <option value="flexible">Flexibil</option>
                                                            <option value="exchanges">Schimburi</option>
                                                            <option value="weekend_work">Lucru in weekend</option>
                                                            <option value="other">Altul</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Spatiu de lucru</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.userWorkSpace name="userWorkSpace">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="interior">Interior</option>
                                                            <option value="exterior">Exterior</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Disponibilitate efort fizic</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.physicalEffortAvailability name="physicalEffortAvailability">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option class="form-control" value="normal">Normal</option>
                                                            <option class="form-control" value="additional">Suplimentar</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Ridicare greutati</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.weightLiftingAvailability name="weightLiftingAvailability">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option class="form-control" value="no">Nu</option>
                                                            <option class="form-control" value="maximum_10_kg">Pana in 10kg</option>
                                                            <option class="form-control" value="maximum_25_kg">Pana in 25kg</option>
                                                            <option class="form-control" value="maximum_50_kg">Pana in 50kg</option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Diferite temperaturi</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.workTemperature name="workTemperature">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="no">Nu</option>
                                                            <option value="yes">Da</option>
                                                            <option value="low_temperature">Doar la temepraturi scazute
                                                            </option>
                                                            <option value="high_temperature">Doar la temepraturi ridicate
                                                            </option>
                                                        </select>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Dispus naveta</label>
                                                        <select class="form-control"
                                                                [(ngModel)]=candidate.userCommute name="userCommute">
                                                            <option value=""> -- Selecteaza optiune --</option>
                                                            <option value="no">Nu</option>
                                                            <option value="maximum_100_km">Pana in 100km</option>
                                                            <option value="maximum_500_km">Pana in 500km</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                        <ngb-panel id="sal-pack">
                                            <ng-template ngbPanelTitle>
                                                <span class="card-header--title">Pachet salarial ideal</span>
                                            </ng-template>
                                            <ng-template ngbPanelContent>
                                                <div class="row">
                                                    <div class="col-md-3 form-group">
                                                        <label>Interesat de bonusare</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="interestedInBonusSystem" class="form-control"
                                                                   [(ngModel)]=candidate.interestedInBonusSystem>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Bonuri de masa</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryMealVoucher" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryMealVoucher>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Bonuri de vacanta</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryHolidayVoucher" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryHolidayVoucher>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Masina de serviciu</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryServiceCar" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryServiceCar>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Pachet de sanatate</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryHealthPackage" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryHealthPackage>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Masa obligatorie</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryFood" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryFood>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Cazare obligatorie</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="mandatoryAccommodation" class="form-control"
                                                                   [(ngModel)]=candidate.mandatoryAccommodation>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Cursuri in tara</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="coursesInTheCountry" class="form-control"
                                                                   [(ngModel)]=candidate.coursesInTheCountry>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                    <div class="col-md-3 form-group">
                                                        <label>Cursuri in afara tarii</label>
                                                        <label class="checkbox-container">DA
                                                            <input type="checkbox" name="coursesInTheCountry" class="form-control"
                                                                   [(ngModel)]=candidate.coursesAboard>
                                                            <span class="checkmark"></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            </ng-template>
                                        </ngb-panel>
                                    </ngb-accordion>
                                </div>
                            </div>
                            <div class="row mt-5">
                                <div class="col-md-6 text-right form-group">
                                    <button class="btn btn-light-danger font-weight-bold btn-block"
                                            type="button"
                                            (click)="resetForm(searchForm)">
                                        <span class="fa fa-search"></span> Resetare
                                    </button>
                                </div>
                                <div class="col-md-6 text-right form-group">
                                    <button class="btn btn-light-primary font-weight-bold btn-block"
                                            type="button"
                                            (click)="candidatesCall();">
                                        <span class="fa fa-search"></span> Cautare
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </form>




        <div class="col-lg-12 pt-3">
            <hr>
            <div class="d-flex align-items-center justify-content-between">
                <div>
                    <label class="mb-0">Nr. total de rezultate: {{totalElements}}</label>
                </div>

                <div>
                    <button type="button" class="btn btn-secondary" (click)="exportexcel()">Exporta in .xlsx <i class="icofont-file-excel"></i></button>
                </div>
            </div>
            <hr>
            <div class="row mt-5 mb-5 just">
                <div class="col-md-3">
                    <div class="d-flex align-items-center">
                        <label class="mr-3 mb-0">Rezultate: </label>
                        <select (change)="onSizeChange($event)" class="form-control">
                            <option *ngFor="let size of pageSizes" [ngValue]="size">
                                {{ size }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6 offset-3">
                    <div class="d-flex align-items-center justify-content-end">
                        <div class="col-md-6 d-flex align-items-center">
                            <label class="mr-3 mb-0">Sortare: </label>
                            <select (change)="onSortChange($event)" class="form-control">
                                <option [ngValue]="undefined"> -- Alege -- </option>
                                <option *ngFor="let item of sortingValues" value="{{item.value}}">{{item.name}}</option>

                            </select>
                        </div>
                        <div class="col-md-6 d-flex align-items-center">
                            <label class="mr-3 mb-0">Ordonare: </label>
                            <select (change)="onOrderChange($event)" class="form-control">
                                <option [ngValue]="undefined"> -- Alege -- </option>
                                <option value="asc">Ascendent</option>
                                <option value="desc">Descendent</option>
                            </select>
                        </div>

                    </div>
                </div>
            </div>

            <ngb-alert #selfClosingAlert *ngIf="successMessage" type="success" (closed)="successMessage = ''">{{ successMessage }}
            </ngb-alert>

            <ngb-alert #selfClosingError *ngIf="errorMessage" type="danger" (closed)="errorMessage = ''">{{ errorMessage }}
            </ngb-alert>
            <!--begin::Table-->
            <div class="table-responsive mt-3">
                <table
                        class="table table-head-custom table-vertical-center"
                        id="candidatesTable"
                >
                    <thead>
                    <tr class="text-left">
                        <th class="pr-0 pl-0" style="width: 150px">Prenume</th>
                        <th style="min-width: 150px">Nume</th>
                        <th style="min-width: 150px">Email</th>
                        <th>Blacklist</th>
                        <th class="pr-0 text-right" style="min-width: 150px">Actiuni</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let candidate of filteredCandidates.content">
                        <ng-template #addBlacklist let-c="close" let-d="dismiss">
                            <div class="modal-header">
                                <h4 class="modal-title" *ngIf="candidate['blackListed'] === false">Adaugare in blacklist - {{candidate["firstName"]}} {{candidate["lastName"]}}</h4>
                                <h4 class="modal-title" *ngIf="candidate['blackListed'] === true">Eliminare din blacklist - {{candidate["firstName"]}} {{candidate["lastName"]}}</h4>
                                <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div  *ngIf="candidate['blackListed'] === false">
                                <div class="modal-body">
                                    <div class="form-group">
                                        <label>Motiv</label>
                                        <textarea [(ngModel)]="reason" name="reason" class="form-control"></textarea>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" (click)="c('Close click')">Anulare</button>
                                    <button type="button" class="btn btn-primary" (click)="c('Close click');
                                changeStatus(candidate['id'], candidate['firstName'], candidate['lastName'], candidate['blackListed'], reason, type)">Adaugare</button>
                                </div>
                            </div>
                            <div  *ngIf="candidate['blackListed'] === true">
                                <div class="modal-body">
                                    <p> Esti sigur ca vrei sa scoti candidatul din blacklist?</p>
                                </div>
                                <div class="modal-footer">
                                    <button type="button" class="btn btn-secondary" (click)="c('Close click')">NU</button>
                                    <button type="button" class="btn btn-primary" (click)="c('Close click');
                                changeStatus(candidate['id'], candidate['firstName'], candidate['lastName'], candidate['blackListed'], reason, type)">DA</button>
                                </div>
                            </div>
                        </ng-template>

                        <td class="pl-0">
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{candidate["firstName"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">{{candidate["lastName"]}}</p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg">
                            <span>
                                {{candidate["email"]}}
                            </span>
                            </p>
                        </td>
                        <td>
                            <p class="text-dark-75 font-weight-bolder font-size-lg blackListStatus mb-0">
                                <span *ngIf="candidate['blackListed'] === false" class="btn btn-light-success">NU</span>
                                <button type="button" *ngIf="candidate['blackListed'] === true"  class="btn btn-light-danger"  placement="top" ngbTooltip="{{candidate['blacklistedReason']}}" ngbTooltipClass="kt-tooltip">DA</button>
                            </p>
                        </td>
                        <td class="pr-0 text-right">
                            <a class="btn btn-icon btn-success btn-hover-primary btn-sm"
                               routerLink="/profil-candidat/{{candidate['id']}}" target="_blank" ngbTooltip="Vezi" placement="bottom">
                                <i class="icofont-eye-alt"></i>
                            </a>
                            <a class="btn btn-icon btn-danger btn-hover-primary btn-sm mx-3" *ngIf="candidate['blackListed'] === false"
                               (click)="openSmall(addBlacklist)"
                               ngbTooltip="Adauga in blacklist" placement="bottom">
                                <i class="icofont-exclamation-tringle"></i>
                            </a>
                            <a class="btn btn-icon btn-warning btn-hover-primary btn-sm mx-3" *ngIf="candidate['blackListed'] === true"
                               (click)="openSmall(addBlacklist)"
                               ngbTooltip="Eliminare din blacklist" placement="bottom">
                                <i class="icofont-ui-check"></i>
                            </a>
                        </td>

                    </tr>
                    </tbody>
                </table>

            </div>
            <!--end::Table-->
        </div>
        <div class="col-md-12 mt-5">
            <ngb-pagination class="d-flex justify-content-center"
                            [(page)]="page"
                            [pageSize]="size"
                            [maxSize]="5"
                            [collectionSize]="totalElements"
                            (pageChange)="onPageChange(page)"
            ></ngb-pagination>
        </div>
        <!--end::Body-->
    </div>
